/**
 * Created by mukund on 8/25/17.
 */
angular.module('mediacloudApp')
    .directive('lmsFileMetadata', function(){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/lms/directives/file-metadata/file-metadata.html',
            scope: {
                file : '=',
                parent: '=',
                assignments: '=',
                summary: '='
            },
            link: function(scope, element, attrs){
                scope.maxDescriptionLength = 255;
                scope.changeDestination = function(destination){
                    scope.file.metadata.destination = destination;
                };
            }
        }

    });
